/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'email-forbidden-stroke': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<desc>envelope postal disable block</desc><g stroke-linecap="round" stroke-width="1.5" _stroke="currentColor" _fill="none" stroke-linejoin="round"><path pid="0" d="M17.25 11.25a6 6 0 100 12 6 6 0 100-12zM13.01 21.49l8.48-8.48"/><path pid="1" d="M8.25 15.75h-6l-.01-.001a1.51 1.51 0 01-1.5-1.5V2.238c0-.83.67-1.5 1.5-1.5h18-.01c.82-.01 1.5.67 1.5 1.5 0 0 0 0 0 0v6.75"/><path pid="2" d="M21.411 1.3l-8.15 6.26v-.01a3.33 3.33 0 01-4.04 0L1.07 1.28"/></g>'
  }
})
